import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchUsersMe, usersQueries } from '@/entities/user';
import { courseQueries } from '@/entities/course';

interface UseUpdateServerPlaybackModeParams {
  courseId: string;
}

export const useUpdateServerPlaybackMode = ({
  courseId,
}: UseUpdateServerPlaybackModeParams) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['update-server-playback-mode'],
    mutationFn: patchUsersMe,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: usersQueries.me().queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: courseQueries.detail(courseId).queryKey,
        }),
      ]);
    },
  });
};
